// frontend/book-app-frontend/src/components/AdminDashboard.js
import React from 'react';
import { Outlet } from 'react-router-dom';

function AdminDashboard() {
  return (
    <div >
      <h1>Admin Dashboard</h1>
      <Outlet /> {/* Renderiza o componente da sub-rota atual */}
    </div>
  );
}

export default AdminDashboard;